/**
 * Which stretch of the song a chat render covers. A preview is a window of up
 * to 20 seconds starting at startBeat. The offline render runs from the top to
 * the window's end, so notes, reverb and delay tails entering the window sound
 * exactly as in playback, and the caller keeps only the window. A full export
 * is the whole song (up to ten minutes) and always starts at the top.
 */
export function previewWindow({ durationSeconds, bpm, startBeat = 0, maxSeconds = 20, fullSessionExport = false }) {
  const end = durationSeconds + 1;
  if (fullSessionExport) {
    return { startSeconds: 0, renderSeconds: Math.min(end, Math.max(1, Math.min(600, Number(maxSeconds) || 20))) };
  }
  const length = Math.max(1, Math.min(20, Number(maxSeconds) || 20));
  const startSeconds = Math.max(0, ((Number(startBeat) || 0) * 60) / bpm);
  if (startSeconds > 0 && startSeconds >= durationSeconds) throw new Error('The preview start is past the end of the music.');
  return { startSeconds, renderSeconds: Math.min(end, startSeconds + length) };
}
